import axios from 'axios';
import useFetchCredential from '../../hooks/useFetchCredential';
import DashboardTable from '../../components/mainDash/DashboardTable';
import DashCards from '../../components/mainDash/DashCards';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
axios.defaults.withCredentials = true;

const MainDashboard = () => {
  const history = useNavigate();
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/dashboard`
  );

  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);

  const subDate = new Date();
  function addOneYear(date) {
    date.setFullYear(date.getFullYear() + 1);
    return date;
  }
  const expiryDate = addOneYear(new Date());

  const becomeConsultant = async () => {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/marketers/become-consultant`, {
      subDate,
      expiryDate,
    });
    const response = res.data;
    if (res.status !== 200) {
      errorNotification(response.message);
    }
    if (res.status === 200) {
      successNotification(response.message);
      setTimeout(() => {
        history(`/investment-details/${response.data.transactionID}`);
      }, 2000);
    }
  };

  if (data?.firstLogin) {
    errorNotification(
      'Before anything, you need to complete your registration first. Fill the remaining fields in the next screen'
    );
    setTimeout(() => {
      history('/edit-profile');
    }, 5000);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketer Dashboard - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User dashboard page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      {data && (
        <>
          <div className="mainDash">
            <h1 className="pageTitle">Dashboard</h1>

            <h3 className="subtitle">
              Welcome, {data.fName} <br />
              <br />
              <div className="subtitle">
                Level: <span style={{ color: '#26683c' }}>{data.level}</span> &nbsp; Earning:
                <span style={{ color: '#26683c' }}>
                  {data.level === 'marketer' ? '10%, 5%, 2% ' : '15%, 7.5%, 3% '}
                </span>
              </div>
            </h3>

            {data.consultant_status === 'marketer' ? (
              <h4 className="headerInfo">
                You can see your earning overview here. Note that you are still a general{' '}
                <b>Marketer</b>. To upgrade to a <b>Consultant level</b> which takes your earning to
                unbelivable (15% on direct referrals, 7.5% on indirect referrals and 3% on grand
                indirect referrals), &nbsp;
                <Link to="" onClick={becomeConsultant}>
                  click here
                </Link>
              </h4>
            ) : data.consultant_status === 'consultant' ? (
              <h4 className="headerInfo">
                You can see your earning overview here. Congratulations as you are already a
                respected
                <b> Consultant</b> in our company. This opens a door to several opportunities for
                you on our ecosystem. To read about these opportunities,
                <Link to={`${process.env.REACT_APP_WEBSITE_URL}/marketers`}>click here</Link>
              </h4>
            ) : (
              <h4 className="headerInfo">
                You can see your earning overview here. Congratulations as your attempt to become a
                respected
                <b> Consultant</b> in our company is being reviewed. Be sure to have made the
                payment to the account details provided. If you have some trouble doing that, be
                sure to reach out to us.
              </h4>
            )}
            <DashCards />
            <DashboardTable />
          </div>
        </>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '25px' }}>{error}</div>}
    </>
  );
};

export default MainDashboard;
